import { useQueryParam } from '../../../shared/router/useQueryParam';
import { useMyBookingsStore } from '../../domain/booking/stores/useMyBookingsStore';

export function useBookingForUrlQuery() {
	const myBookingsStore = useMyBookingsStore();
	const reference = useQueryParam('reference');

	if (!reference) {
		return { isLoading: myBookingsStore.isLoading };
	}

	return {
		booking: myBookingsStore.findBookingByReference(reference),
		isLoading: myBookingsStore.isLoading,
	};
}
